export default "__VITE_ASSET__D4r$Qv8G__"